import { useEffect, useState } from "react";

import { isOlderThan } from "utils/version";

import { fetchMinClientVersion } from "./requiredUpdate";

export type RequiredUpdate = "pending" | "required" | "none";

/**
 * Whether the running version is below the deployed minimum client version, checked once on load.
 * A server that can't be reached never requires an update.
 */
export function useRequiredUpdate({
    currentVersion,
    fetchMinVersion = fetchMinClientVersion,
}: {
    currentVersion: string;
    fetchMinVersion?: () => Promise<string | undefined>;
}): RequiredUpdate {
    const [requiredUpdate, setRequiredUpdate] = useState<RequiredUpdate>("pending");

    useEffect(() => {
        let cancelled = false;
        void fetchMinVersion().then((min) => {
            if (!cancelled) {
                setRequiredUpdate(min !== undefined && isOlderThan(currentVersion, min) ? "required" : "none");
            }
        });
        return () => {
            cancelled = true;
        };
    }, [currentVersion, fetchMinVersion]);

    return requiredUpdate;
}
